import api from 'api'
import DBUtil from '@utils/DBUtil'

const dailyReview = {
  namespaced: true,
  state: {
    daily_review_list: localStorage.daily_review_list ? JSON.parse(localStorage.daily_review_list) : [], //每日回顾列表
    enable_homepage_notification: localStorage.enable_homepage_notification
      ? localStorage.enable_homepage_notification
      : '0', // 首页通知
    lastRefreshTime: localStorage.lastRefreshDate ? localStorage.lastRefreshDate : null, // 拉取每日回顾 list 时间
    progress: '-1', // 每日回顾进度
    currentReviewMemo: null, // 当前回顾 memo
    daily_review_reminder: localStorage.daily_review_reminder ? localStorage.daily_review_reminder : '0', // 每日回顾通知
    showDailyReviewCard: false, // 每日回顾卡片
    showRefreshTips: false, // 显示刷新提示
    showBindWeixinTips: localStorage.showBindWeixinTips ? localStorage.showBindWeixinTips : '1', // 显示绑定微信提示
    useSuggestions: false, // 使用建议
  },
  getters: {
    dailyReviewList: (state) => state.daily_review_list,
    enableHomepageNotification: (state) => state.enable_homepage_notification,
    lastRefreshTime: (state) => state.lastRefreshTime,
    progress: (state) => state.progress,
    // 当前回顾 memo
    currentReviewMemoSlug: async (state) => {
      const dailyReviewList = state.daily_review_list
      const progress = state.progress
      const currentReviewMemoSlug = dailyReviewList[progress == 0 ? 0 : progress - 1]
      //const currentReviewMemo = await DBUtil.getMemo(currentReviewMemoSlug)
      return currentReviewMemoSlug
    },
    currentReviewMemo: (state) => state.currentReviewMemo,
    dailyReviewReminder: (state) => state.daily_review_reminder,
    showDailyReviewCard: (state) => state.showDailyReviewCard,
    showRefreshTips: (state) => state.showRefreshTips,
    showBindWeixinTips: (state) => state.showBindWeixinTips,
    useSuggestions: (state) => state.useSuggestions,
  },
  mutations: {
    setDailyReviewList(state, daily_review_list) {
      state.daily_review_list = daily_review_list
      localStorage.daily_review_list = JSON.stringify(daily_review_list)
    },
    setEnableHomepageNotification(state, enable_homepage_notification) {
      state.enable_homepage_notification = enable_homepage_notification
      localStorage.enable_homepage_notification = state.enable_homepage_notification
    },
    updateLastRefreshTime(state, time) {
      state.lastRefreshTime = time
      state.daily_review_reminder = 0
      localStorage.lastRefreshDate = state.lastRefreshTime
      localStorage.daily_review_reminder = state.daily_review_reminder
    },
    updateProgress(state, progress) {
      state.progress = progress
    },
    updateCurrentReviewMemo(state, currentReviewMemo) {
      state.currentReviewMemo = currentReviewMemo
    },
    updateDailyReviewReminder(state, daily_review_reminder) {
      state.daily_review_reminder = daily_review_reminder
      localStorage.daily_review_reminder = state.daily_review_reminder
    },
    updateShowDailyReviewCard(state, showDailyReviewCard) {
      state.showDailyReviewCard = showDailyReviewCard
    },
    updateShowRefreshTips(state, showRefreshTips) {
      state.showRefreshTips = showRefreshTips
    },
    updateShowBindWeixinTips(state, showBindWeixinTips) {
      state.showBindWeixinTips = showBindWeixinTips
      localStorage.showBindWeixinTips = state.showBindWeixinTips
    },
    updateUseSuggestions(state, useSuggestions) {
      state.useSuggestions = useSuggestions
    },
  },
  actions: {
    //shouldRefreshData({ state, commit }) {
    //  const now = new Date()
    //  const lastRefreshTime = state.lastRefreshTime
    //  // for test
    //  //const lastRefreshTime = localStorage.lastRefreshDate
    //  if (!lastRefreshTime) {
    //    commit('updateLastRefreshTime', now.getTime())
    //    return true
    //  }
    //  const lastRefreshDate = new Date(parseInt(lastRefreshTime))
    //  const isSameDay =
    //    now.getFullYear() === lastRefreshDate.getFullYear() &&
    //    now.getMonth() === lastRefreshDate.getMonth() &&
    //    now.getDate() === lastRefreshDate.getDate()
    //  if (!isSameDay) {
    //    commit('updateLastRefreshTime', now.getTime())
    //    // 如果当前显示每日回顾卡片，显示刷新提示
    //    if (state.showDailyReviewCard) {
    //      commit('updateShowRefreshTips', true)
    //    }
    //    return true
    //  }
    //  return false
    //},
    //  检查每日回顾数据是否有删除的
    async getNewReviewList({ state, commit }, dailyReviewList) {
      const res = await DBUtil.getNewReviewList(dailyReviewList)
      return res
    },
    async getDailyReview({ state, commit }) {
      //const shouldRefreshData = await this.dispatch('dailyReview/shouldRefreshData')
      //if (!shouldRefreshData) {
      //  return
      //}
      const {
        data: { data },
      } = await api.callPromise('GET', '/memo/notify_of_today/', { dau_stat: 1 })
      const reviewList = await this.dispatch('dailyReview/getNewReviewList', data)
      commit('updateDailyReviewReminder', 0)
      commit('setDailyReviewList', reviewList)
      this.dispatch('dailyReview/getCurrentReviewMemo')
    },
    async getReviewSetting({ state, commit }) {
      api.call('get', '/notify_setting/mine/', { type: 'inapp' }, async (response) => {
        if (response.data && response.data.code === 0) {
          commit('setEnableHomepageNotification', response.data.data.length ? response.data.data[0].home_notify : '0')
        }
      })
    },
    async getProgress({ state, commit }) {
      const {
        data: {
          data: { progress, notify_setting_exists },
        },
      } = await api.callPromise('GET', '/notify_memo_progress/', {})
      if (state.daily_review_list.length && progress > state.daily_review_list.length) {
        progress = state.daily_review_list.length
      }
      commit('updateProgress', progress)
      commit('updateUseSuggestions', !notify_setting_exists)
    },
    // 同步progress
    async syncProgress({ state, commit }, progress) {
      if (progress > state.daily_review_list.length) {
        progress = state.daily_review_list.length
        commit('updateProgress', progress)
        return
      }

      api.call('POST', '/notify_memo_progress/', { progress }, (response) => {
        if (response.data && response.data.code === 0) {
          commit('updateProgress', response.data.data.progress)
        }
      })
    },

    // 获取当前回顾 memo
    async getCurrentReviewMemo({ state, commit, getters }) {
      const currentReviewMemoSlug = await getters.currentReviewMemoSlug
      const { progress, daily_review_list } = state

      if (progress - 1 > daily_review_list.length) {
        return
      }
      if (currentReviewMemoSlug) {
        const currentReviewMemo = await DBUtil.getMemo(currentReviewMemoSlug)
        commit('updateCurrentReviewMemo', currentReviewMemo)
      }
    },

    async getReviewMemo({ state }, progress) {
      if (progress > state.daily_review_list.length) {
        return
      }
      const slug = state.daily_review_list[progress - 1]
      const memo = await DBUtil.getMemo(slug)
      return memo
    },
    // 根据 progress 获取当前回顾 memo
    async getCurrentReviewMemoByProgress({ commit }, progress) {
      const memo = await this.dispatch('dailyReview/getReviewMemo', progress)
      commit('updateCurrentReviewMemo', memo)
    },

    setDailyReviewReminder({ commit }, daily_review_reminder) {
      commit('updateDailyReviewReminder', daily_review_reminder)
    },
    setShowDailyReviewCard({ commit }, showDailyReviewCard) {
      commit('updateShowDailyReviewCard', showDailyReviewCard)
      commit('updateDailyReviewReminder', showDailyReviewCard ? 1 : 0)
    },
    // 删除每日回顾
    async deleteDailyReview({ state, commit }, slug) {
      const dailyReviewList = state.daily_review_list
      const index = dailyReviewList.indexOf(slug)
      if (index > -1) {
        dailyReviewList.splice(index, 1)
        commit('setDailyReviewList', dailyReviewList)
      }
    },
    // 显示刷新提示
    async setRefreshTips({ commit }, show) {
      commit('updateShowRefreshTips', show)
    },

    setCurrentReviewMemo({ commit }, currentReviewMemo) {
      commit('updateCurrentReviewMemo', currentReviewMemo)
    },
    // 判断获取的每日回顾列表和本地存储的是否一致
    async checkDailyReviewList({ state, commit }, list) {
      if (state.daily_review_list.length === 0) {
        commit('updateShowRefreshTips', false)
        return true
      }
      if (list.length !== state.daily_review_list.length) {
        if (state.showDailyReviewCard) {
          commit('updateShowRefreshTips', true)
        }
        return true
      }
      // 检查list 和 daily_review_list 是否一致
      for (let i = 0; i < list.length; i++) {
        if (list[i] !== state.daily_review_list[i]) {
          if (state.showDailyReviewCard) {
            commit('updateShowRefreshTips', true)
          }
          return true
        }
      }
      return false
    },
    setShowBindWeixinTips({ commit }, show) {
      commit('updateShowBindWeixinTips', show)
    },
    setUseSuggestions({ state, commit }, useSuggestions) {
      commit('updateUseSuggestions', useSuggestions)
    },
  },
}

export default dailyReview
